<template>
  <div class="pre-checkout-sidebar-guest">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-login-checkouttitle">
      Checkout
    </div>
    <div class="pre-checkout-sidebar-guest-title">
      {{ t("pre.checkout.sign.up.guest") }}
      <span class="pre-checkout-sidebar-guest-title-subtext">
        {{  t("pre.checkout.enter.email") }}
      </span>
    </div>
    <form class="pre-checkout-sidebar-guest-form"
      accept-charset="utf-8"
      method="post"
      :action="previewOrderUrl"
    >
      <div class="form-group">
        <label class="customer-guest-form-label dioptra-input-label sr-only" for="precheckout-guest-email">Email</label>
        <input id="precheckout-guest-email"
          v-model="email"
          class="form-control"
          name="email"
          placeholder="Το email σου"
          required
          type="email"
        >
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="preview_continue" type="submit" value="true">
        <span>
          {{  t("preview.order.continue") }}
        </span>
      </button>
    </form>
    <div class="pre-checkout-sidebar-guest-actions">
      <div class="pre-checkout-sidebar-guest-actions-return">
        <button class="pre-checkout-sidebar-guest-actions-return-button"
          name="return"
          value="return"
          @click="onReturnBackClick"
        >
          <span class="pos-rel pre-checkout-sidebar-guest-actions-return-button-text">
            {{  t("return") }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'PreCheckoutSidebarGuest',
  data () {
    return {
      email: ''
    }
  },
  computed: {
    ...mapGetters([
      'config'
    ]),
    previewOrderUrl () {
      return `${this.config?.url?.base}preview_order${this.config?.url?.suffix}`
    }
  },
  methods: {
    onReturnBackClick () {
      this.$emit('return-back-click')
    }
  }
}
</script>

<style lang="scss" scoped>

.form-control {
  border: 1px solid #231F20;
  border-radius: unset;
  padding: 10px 25px;
  font-weight: 400;
  color: #231F20;
}

.pre-checkout-sidebar-body-form-button {
  font-size: 19px;
  border-radius: unset;
  width: 100%;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
}
.pre-checkout-sidebar-guest-title {
  display: grid;
  margin-bottom: 30px;
}
.pre-checkout-sidebar-guest-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1A1818;
}

.pre-checkout-sidebar-guest-title-subtext {
  font-size: 13px;
  color: #1A1818;
  font-weight: 400;
  display: block;
  width: 100%;
  margin-top: 0.625rem;
  line-height: 1.3
}

.pre-checkout-sidebar-guest-actions {
  display: grid;
  gap: 100px;
  align-items: center;
  align-content: space-between;
}

.pre-checkout-sidebar-guest-actions-return {
  display: grid;
  gap: 14px;
}

</style>
